/**
 * Refresh the page-list table and summary cards after a mutation.
 * Stats components expose refresh() via an imperative ref.
 */
export function refreshPageListAfterMutation({ fetchData, statsRef } = {}) {
  if (typeof fetchData === "function") fetchData();
  statsRef?.current?.refresh?.();
}
